import routerOptions0 from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}